import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle'

import classNames from 'classnames'

import Help from '../Help'
import Error from '../Error'

const FormGroup = ({
    name,
    label = '',
    help,
    error,
    children,
    className,
    tooltip,
    charactercount = false,
    required = false,
}) => (
    <div
        className={classNames('form-group', {
            'has-error': error,
            [`${className}`]: className,
        })}
    >
        <div className="!flex !justify-between !items-center">
            {label.length > 0 && (
                <span>
                    <label
                        htmlFor={name}
                        className={classNames({
                            '!mb-1': !help,
                            '!mb-0': help,
                            required: required === true,
                        })}
                    >
                        {label}
                    </label>

                    {tooltip && (
                        <span
                            data-tooltip={tooltip}
                            className={classNames('!ml-2', {
                                'tooltip-wrap': tooltip.length > 50,
                            })}
                        >
                            <FontAwesomeIcon icon={faInfoCircle} />
                        </span>
                    )}
                </span>
            )}

            {charactercount !== false && (
                <p className="!mb-0" data-testid={`${name}_character-count`}>
                    Character Count: <strong>{charactercount}</strong>
                </p>
            )}
        </div>
        {help && <Help className="!mt-0 !mb-2" id={`${name}Help`} help={help} />}
        {children}
        {error && <Error error={error} name={name} />}
    </div>
)

FormGroup.displayName = 'FormGroup'

FormGroup.propTypes = {
    name: PropTypes.string.isRequired,
    help: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    children: PropTypes.any,
    className: PropTypes.string,
}

export default FormGroup
